// ../../Functions.js/Embossing.js
import { platecost } from "../Pages/Est/Calcs";

export function calculateTotalCost(item, length, width, embossmr) {
  const w = (parseFloat(width) || 0) + 1;
  const l = (parseFloat(length) || 0) + 1;
  const squareinch = w * l;

  // Always create a fresh copy
  const newItem = { ...item };

  // Ensure emboss object exists
  if (!newItem.emboss) {
    newItem.emboss = { state: true, width: 0, length: 0, platecost: 0, embossmr: 50 };
  }

  if (squareinch <= 0) {
    newItem.totalPrice = (parseFloat(newItem.totalPrice) || 0).toFixed(2);
    return newItem;
  }

  const plate = platecost.find(p => p.squareinch === squareinch);
console.log(plate)
  // Update emboss values safely
  newItem.emboss.width = parseFloat(width) || 0;
  newItem.emboss.length = parseFloat(length) || 0;
  newItem.emboss.platecost = plate ? parseFloat(plate.cost) : 0;
  newItem.emboss.embossmr = parseFloat(embossmr) || 50;

  // Optional: store die size for display
  newItem.emboss.dieSize = `${w.toFixed(1)}×${l.toFixed(1)} in`;

  console.log("calculateTotalCost result:", newItem);
  return newItem;
}


  
export function calculateEmbossCost(item, length, width, embossmr = 50) {
  const rawWidth = parseFloat(width) || 0;
  const rawLength = parseFloat(length) || 0;

  // Actual sheet size (what goes through the press)
  const sheetW = rawWidth;
  const sheetL = rawLength;

  // Determine run rate per thousand
  const isSmallSheet = sheetW <= 11 && sheetL <= 17;
  const runRatePerThousand = isSmallSheet ? 50.0 : 75.0;
console.log(isSmallSheet)
console.log(runRatePerThousand)

  // Plate calculation: +1" on each dimension (standard die making rule)
  const dieW = rawWidth + 1;
  const dieL = rawLength + 1;
  const squareInch = dieW * dieL;
console.log(squareInch)

  // Find plate cost from lookup table
  const plateEntry = platecost.find(p => Math.round(p.squareinch) === Math.round(squareInch));
  const plateCost = plateEntry ? parseFloat(plateEntry.cost) : 0;

  // Build fresh result
  const result = {
    ...item,
    emboss: {
      ...(item.emboss || {}),
      state: true,
      width: rawWidth,
      length: rawLength,
      platecost: plateCost,
      dieSize: `${dieW.toFixed(1)} × ${dieL.toFixed(1)} in`,
      embossmr: parseFloat(embossmr) || 50,
      runRatePerThousand: runRatePerThousand,     // $50 or $75
      runCostPerUnit: runRatePerThousand / 1000   // e.g. 0.050 or 0.075 per piece
    }
  };

  return result;
}